// Packages
import axios from "axios";
// Constants
import {
  ADMIN_INSPECT,
  API_AUTH_CUSTOMER,
  API_AUTH_ME,
  API_BASE_URL,
  API_DOWNLOAD_FILE,
  API_GET_BRANCHES,
  API_SAVE_ACCOUNT,
  API_SAVE_REQUEST,
  API_SMS_VALIDATION,
  API_VALIDATE_ACCOUNT,
  API_VALIDATE_CUSTOMER,
  CANCEL_REQUEST,
  GET_ADDRESS_INFO,
  GET_ANIMAL_BREEDS,
  GET_ANIMAL_BY_OWNER_ID,
  GET_ANIMAL_GENDERS,
  GET_ANIMAL_OWNERS,
  GET_ANIMAL_TYPES,
  GET_APPOINTMENT_STATUS,
  GET_CUSTOMER_APPOINTMENTS,
  GET_CUSTOMER_RESULTS,
  GET_DISTRICT_BY_TOWN,
  GET_OWNER_WITH_ANIMALS,
  GET_RATEM_ALL_REQUESTS,
  GET_REQUEST_BY_ID,
  GET_REQUEST_LIST,
  GET_RESULT_LIST,
  GET_RESULT_URL,
  GET_TEST_GROUPS,
  UPDATE_REQUESTS,
  ADMIN_INSPECT_CUSTOMER,
  ADMIN_AUTH_EVET_LOGIN,
} from "./Constants";
// Helpers
import { StorageHelpers } from "./Helpers";
const Api = {
  _axiosInstance: ({ withToken = true }) => {
    let config = {
      baseURL: API_BASE_URL,
      validateStatus: (status) => {
        return true; // I'm always returning true, you may want to do it depending on the status received
      },
    };

    if (withToken) {
      const usertoken = StorageHelpers.getUserAuthToken();
      const authtoken = StorageHelpers.getAuthToken();
      config.headers = {
        Authorization: `Bearer ${authtoken === null ? usertoken : authtoken}`,
      };
    }

    return axios.create(config);
  },

  saveRequestAsync: async (model) => {
    return await Api._axiosInstance({}).post(API_SAVE_REQUEST, model);
  },

  validateAccountAsync: async ({ firmType, idNo, gsm, isRegister = true, idBranch }) => {
    return await Api._axiosInstance({ withToken: false }).post(API_VALIDATE_ACCOUNT, {
      firmType,
      idNo,
      gsm,
      isRegister,
      idBranch: Number(idBranch),
    });
  },

  validateCustomerAsync: async ({ identityNr, gsm, idBranch }) => {
    return await Api._axiosInstance({ withToken: false }).post(API_VALIDATE_CUSTOMER, {
      identityNr,
      gsm,
      idBranch: Number(idBranch),
    });
  },
  authCustomerAsync: async ({ identityNr, gsm, gsmCode, idBranch }) => {
    return await Api._axiosInstance({ withToken: false }).post(API_AUTH_CUSTOMER, {
      identityNr,
      gsm,
      gsmCode,
      idBranch: Number(idBranch),
    });
  },

  smsCodeValidationAsync: async ({ firmType, idNo, gsm, gsmCode, idBranch }) => {
    return await Api._axiosInstance({ withToken: false }).post(API_SMS_VALIDATION, {
      firmType,
      idNo,
      gsm,
      gsmCode,
      idBranch: Number(idBranch),
    });
  },

  smsCodeEvetLoginAsync: async ({ firmType, identityNr, gsm, gsmCode, idBranch }) => {
    return await Api._axiosInstance({ withToken: false }).post(ADMIN_AUTH_EVET_LOGIN, {
      firmType,
      identityNr,
      gsm,
      gsmCode,
      idBranch: Number(idBranch),
    });
  },

  adminLoginInspectAsync: async (model) => {
    return await Api._axiosInstance({ withToken: false }).post(ADMIN_INSPECT, model);
  },

  adminLoginInspectCustomerAsync: async (model) => {
    return await Api._axiosInstance({ withToken: false }).post(ADMIN_INSPECT_CUSTOMER, model);
  },

  getBranchesAsync: async () => {
    return await Api._axiosInstance({ withToken: false }).get(API_GET_BRANCHES);
  },

  saveAccountAsync: async (model) => {
    return await Api._axiosInstance({ withToken: false }).post(API_SAVE_ACCOUNT, {
      ...model,
      idBranch: Number(model.idBranch),
      idDistrict: Number(model.idDistrict),
      idTown: Number(model.idTown),
      idCity: Number(model.idCity),
    });
  },

  authMeAsync: async (model) => {
    return await Api._axiosInstance({}).post(API_AUTH_ME, model);
  },

  getCustomerResultsAsync: async (recCount, pageNumber) => {
    return await Api._axiosInstance({}).post(GET_CUSTOMER_RESULTS, {
      recCount,
      pageNumber,
    });
  },

  getCustomerAppointmentsAsync: async (recCount, pageNumber) => {
    return await Api._axiosInstance({}).post(GET_CUSTOMER_APPOINTMENTS, {
      recCount,
      pageNumber,
    });
  },

  updateRequestAsync: async (model) => {
    return await Api._axiosInstance({}).post(UPDATE_REQUESTS, model);
  },

  getAppointmentStatusAsync: async () => {
    return await Api._axiosInstance({}).get(GET_APPOINTMENT_STATUS);
  },

  getRequestListAsync: async (recCount, pageNumber, status) => {
    return Api._axiosInstance({}).post(GET_REQUEST_LIST, {
      recCount,
      pageNumber,
      status,
    });
  },

  getRatemRequestListAsync: async (recCount, pageNumber) => {
    return Api._axiosInstance({}).post(GET_RATEM_ALL_REQUESTS, {
      recCount,
      pageNumber,
    });
  },
  cancelRequestAsync: async (id) => {
    return Api._axiosInstance({}).post(CANCEL_REQUEST, { id });
  },

  getResultList: async (recCount, pageNumber) => {
    return Api._axiosInstance({}).post(GET_RESULT_LIST, {
      recCount,
      pageNumber,
    });
  },

  getOwnerWithAnimalsAsync: async (recCount, pageNumber) => {
    return Api._axiosInstance({}).post(GET_OWNER_WITH_ANIMALS, {
      recCount,
      pageNumber,
    });
  },

  downloadFileAsync: async (idFile) => {
    return await Api._axiosInstance({}).post(`${API_DOWNLOAD_FILE}?IDFile=${idFile}`);
  },
  getResultUrlAsync: async (idRequest) => {
    return Api._axiosInstance({}).post(`${GET_RESULT_URL}?IDRequest=${idRequest}`);
  },

  getAddressInfoAsync: async () => {
    return await Api._axiosInstance({ withToken: false }).get(GET_ADDRESS_INFO);
  },

  getDistrictByCountryAsync: async (idTown) => {
    return await Api._axiosInstance({ withToken: false }).get(`${GET_DISTRICT_BY_TOWN}?IDTown=${idTown}`);
  },

  getAnimalBreedsAsync: async (animalType) => {
    return await Api._axiosInstance({}).get(`${GET_ANIMAL_BREEDS}?IdAnimalType=${animalType}`);
  },

  getAnimalOwnersAsync: async (itemId) => {
    return Api._axiosInstance({}).get(`${GET_ANIMAL_OWNERS}?IdOwner=${itemId}`);
  },

  getAllAnimalOwnersAsync: async () => {
    return await Api._axiosInstance({}).get(GET_ANIMAL_OWNERS);
  },
  getAnimalOwnerByIdAsync: async (ownerId) => {
    return await Api._axiosInstance({}).get(`${GET_ANIMAL_BY_OWNER_ID}?OwnerId=${ownerId}`);
  },

  getRequestByIdAsync: async (requestId) => {
    return await Api._axiosInstance({}).get(`${GET_REQUEST_BY_ID}?Id=${requestId}`);
  },

  getAnimalTypesAsync: async () => {
    return await Api._axiosInstance({}).get(GET_ANIMAL_TYPES);
  },

  getAnimalGendersAsync: async () => {
    return await Api._axiosInstance({}).get(GET_ANIMAL_GENDERS);
  },

  getTestGroupsAsync: async () => {
    return Api._axiosInstance({}).get(GET_TEST_GROUPS);
  },
};

export default Api;
